export default __webpack_public_path__ + "static/media/crop_type_maize.d3815f94.jpg";